module.exports = __webpack_public_path__ + "img/shopping-cart.599b685a.png";